export const BANNER_TYPES = {
  IMAGE: "Image",
  VIDEO: "Video",
};

export const BANNER_TYPE_OPTIONS = [
  { value: BANNER_TYPES.IMAGE, label: "Image" },
  { value: BANNER_TYPES.VIDEO, label: "Video" },
];

export const BUTTON_STYLES = {
  GREEN: "Green",
  BLUE: "Blue",
  LIGHT: "Light",
};

export const BUTTON_STYLE_OPTIONS = [
  { value: BUTTON_STYLES.GREEN, label: "Green" },
  { value: BUTTON_STYLES.BLUE, label: "Blue" },
  { value: BUTTON_STYLES.LIGHT, label: "Light" },
];

export const MAX_HERO_BANNER_BUTTONS = 3;

export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

export const ALLOWED_IMAGE_ACCEPT = "image/jpeg,image/jpg,image/png,image/webp";
